import React, { useState } from 'react'

import { Iconify } from '../../../../Xmerald-UI'

import { Categories } from './categories'
import {
  ClearSearchButton,
  FiltersRow,
  HistoryButton,
  SearchBarContainer,
  SearchField,
  SearchFieldGroup,
  SearchIcon,
  SearchInput,
  SortButton,
  SortButtonsRow,
  SortDirectionIcon,
} from './top-bar-styled'

export const SORT_OPTIONS = [
  { name: 'Popularidad', value: 'rank' },
  { name: 'Nombre', value: 'name' },
  { name: 'Lanzamiento', value: 'launch_date' },
]

export const SearchBar = ({
  types = [],
  selectedType = 'all',
  onSelectType,
  searchText = '',
  sortBy = 'rank',
  sortDirection = 1,
  onSearchChange,
  onClearSearch,
  onSort,
  onOpenHistory,
}) => {
  const [isFocused, setIsFocused] = useState(false)

  const handleSort = (value) => (event) => {
    event.preventDefault()
    onSort?.(value)
  }

  const handleClearSearch = (event) => {
    event.preventDefault()
    onClearSearch?.()
  }

  const hasSearchText = searchText.trim().length > 0

  return (
    <SearchBarContainer aria-label="Filtros del catálogo">
      <FiltersRow>
        <SearchFieldGroup>
          <SearchField
            $focused={isFocused}
            initial={false}
            animate={{ width: isFocused ? 200 : 200 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
          >
            <SearchIcon $focused={isFocused} aria-hidden="true">
              <Iconify icon="eva:search-fill" width={18} height={18} />
            </SearchIcon>
            <SearchInput
              type="search"
              placeholder="Buscar"
              value={searchText}
              onChange={(event) => onSearchChange?.(event.target.value)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              aria-label="Buscar juegos"
            />
            {hasSearchText ? (
              <ClearSearchButton
                type="button"
                onClick={handleClearSearch}
                aria-label="Limpiar búsqueda"
              >
                <Iconify icon="eva:close-fill" width={18} height={18} />
              </ClearSearchButton>
            ) : null}
          </SearchField>

          <HistoryButton
            type="button"
            onClick={onOpenHistory}
            aria-label="Ver historial de jugadas"
            title="Historial"
          >
            <span>Historial</span>
            <Iconify icon="eva:clock-outline"  />
          </HistoryButton>
        </SearchFieldGroup>

        <SortButtonsRow>
          {SORT_OPTIONS.map((option) => {
            const isActive = sortBy === option.value

            return (
              <SortButton
                key={option.value}
                type="button"
                $active={isActive}
                onClick={handleSort(option.value)}
              >
                {option.name}
                {isActive ? (
                  <SortDirectionIcon aria-hidden="true">
                    {sortDirection === 1 ? (
                      <Iconify icon="eva:arrow-down-fill" width={14} height={14} />
                    ) : (
                      <Iconify icon="eva:arrow-up-fill" width={14} height={14} />
                    )}
                  </SortDirectionIcon>
                ) : null}
              </SortButton>
            )
          })}
        </SortButtonsRow>
      </FiltersRow>

      <Categories
        types={types}
        selectedType={selectedType}
        onSelect={onSelectType}
      />
    </SearchBarContainer>
  )
}
